import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { db, auth } from "../firebase";
import { Storage } from '../firebase';
import { collection, getDocs, updateDoc, doc as firestoreDoc, getDoc, addDoc, Timestamp } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL, listAll } from 'firebase/storage';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'axios';
import Wallet from '../components/Wallet';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useModal } from '../components/ModalContext';
import '../style/placeorder.css'
import '../style/OrderSample.css'
import { jsPDF } from "jspdf";
import { ToWords } from "to-words";


Modal.setAppElement("#root");

const ProductSelectionPopup = ({ isOpen, onClose, products, onSelectProduct }) => {
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedColorVariant, setSelectedColorVariant] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [neckLabelsStatus, setNeckLabelsStatus] = useState(null);

  const handleSizeChange = (e) => {
    setSelectedSize(e.target.value);
  };
  
  const handleProductSelect = (product) => {
    setSelectedProduct(product);
    setSelectedColorVariant(null); // Reset color variant when a new product is selected
    setSelectedSize(""); // Reset size selection when new product is selected
  };
  
  const handleColorVariantSelect = (colorVariant) => {
    setSelectedColorVariant(colorVariant);
    setSelectedSize(""); // Reset size when a new color variant is selected
  };

     const user = auth.currentUser;
      if (!user) {
          throw new Error("User not logged in");
      }
  

  const checkNeckLabelsEnabled = async (userId) => {
      if (!userId) {
        console.log("User ID is not available");
        return false; // Return false if user ID is missing
      }
      
      try {
        console.log(`Checking neckLabels for user: ${userId}`);
        const userRef = firestoreDoc(db, 'users', userId);
        const userDoc = await getDoc(userRef);
        
        if (userDoc.exists()) {
          const hasNeckLabels = userDoc.data().neckLabels === true;
          console.log(`User has neckLabels: ${hasNeckLabels}`);
          return hasNeckLabels;
        } else {
          console.log('User document does not exist');
          return false;
        }
      } catch (error) {
        console.error("Error fetching user document:", error);
        console.log(`Error details: ${error.message}`);
        return false;
      }
    };
  
  
    
  
  
    useEffect(() => {
      const checkUserNeckLabels = async () => {
        if (user && user.uid) {
          const hasNeckLabels = await checkNeckLabelsEnabled(user.uid);
          setNeckLabelsStatus(hasNeckLabels);
        }
      };
      
      checkUserNeckLabels();
    }, [user]);


    const neckLabelPrice = neckLabelsStatus ? 5 : 0;



  const handleConfirmProduct = () => {
    if (!selectedSize) {
      alert("Please select a size!");
      return;
    }
    
    let finalProduct;
    
    if (selectedColorVariant) {
      finalProduct = {
        ...selectedProduct,
        ...selectedColorVariant,
        selectedSize,
        images: selectedColorVariant.images, // Use variant images
        SKUs: selectedColorVariant.SKUs, // Use variant SKUs
        variantData: selectedColorVariant // Keep reference to the original variant data
      };
    } else {
      // If no color variant, just use the base product
      finalProduct = { ...selectedProduct, selectedSize };
    }
    
    onSelectProduct(finalProduct);
    setSelectedProduct("");
    setSelectedColorVariant("");
    setSelectedSize("");
    onClose();
  };

  const hasColorVariants = (product) => {
    return product.colorVariants && Array.isArray(product.colorVariants) && product.colorVariants.length > 0;
  };

  const filteredProducts = products.filter((product) =>
    product.designName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className="product-selection-modal">
      <h2>Select Product</h2>
      <input
        type="text"
        placeholder="Search by design name..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="product-search"
      />
      <div className="sample-order-product-list">
        {filteredProducts.map((product) => (
          <div
            key={product.id}
            className={`product-item ${selectedProduct?.id === product.id ? 'selected' : ''}`}
            onClick={() => handleProductSelect(product)}
          >
            <div>
              <h3>{product.productName}</h3>
              <p>{product.designName}</p>
              <p>Price: Rs. {product.totalPrice}</p>
              <p>{product.description}</p>
              {hasColorVariants(product) && (
                <span className="variant-badge">Color Variants Available</span>
              )}
            </div>
          </div>
        ))}
      </div>
      
      {/* If a product with color variants is selected, show color variant options */}
      {selectedProduct && hasColorVariants(selectedProduct) && !selectedColorVariant && (
        <div className="color-variant-selection">
          <h3>Select Color Variant for {selectedProduct.productName}</h3>
          <div className="color-variant-options">
            {selectedProduct.colorVariants.map((variant, index) => (
              <div 
                key={index} 
                className="color-variant-item"
                onClick={() => handleColorVariantSelect(variant)}
              >
                <img src={variant.images.front} alt={variant.color || `Color ${index + 1}`} width="40" />
                <img src={variant.images.back} alt={variant.color || `Color ${index + 1}`} width="40" />
                <div>
                  <p>{variant.color || `Color ${index + 1}`}</p>
                  {variant.totalPrice + neckLabelPrice && <p>Price: Rs. {variant.totalPrice + neckLabelPrice}</p>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* If a product is selected (either with or without color variants), show size options */}
      {(selectedProduct && !hasColorVariants(selectedProduct)) || selectedColorVariant ? (
        <div className="sticky-selectsize">
          <h3>Select Size for {selectedProduct.productName} {selectedColorVariant && selectedColorVariant.color? `(${selectedColorVariant.color})` : ''}</h3>
          <select value={selectedSize} onChange={handleSizeChange}>
            <option value="">Select Size</option>
            <option value="S">S</option>
            <option value="M">M</option>
            <option value="L">L</option>
            <option value="XL">XL</option>
          </select>
          <button onClick={handleConfirmProduct}>Confirm Product and Size</button>
        </div>
      ) : null}
      
      <button className="close-button" onClick={onClose}>
        Close
      </button>
    </Modal>
  );
};

const PlaceOrder = () => {
   const location = useLocation();
  const { design } = location.state || {};

      const user = auth.currentUser;
      if (!user) {
        throw new Error("User not logged in");
      }

  const [formData, setFormData] = useState({
    ReferenceID: "",
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    pincode: "",
    state: "",
  });
  const [step, setStep] = useState("product");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState(design ? [{ ...design, selectedSize: "", quantity: 0  }] : []);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPrice, setTotalPrice] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false); // Confirmation Modal state
  const [confirmBalance, setConfirmBalance] = useState(null);
  const [walletBalance, setWalletBalance] = useState(0);
  const [userId, setUserId] = useState(null);
  const [payment, setPayment] = useState(''); // Default is 'Prepaid'
  const [isProcessing, setIsProcessing] = useState(false); 
  const navigate = useNavigate();

  const [selectedSize, setSelectedSize] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [shippingCharge, setShippingCharge] = useState(0);
  const [neckLabelsStatus, setNeckLabelsStatus] = useState(null);


  const checkNeckLabelsEnabled = async (userId) => {
      if (!userId) {
        console.log("User ID is not available");
        return false; // Return false if user ID is missing
      }
      
      try {
        console.log(`Checking neckLabels for user: ${userId}`);
        const userRef = firestoreDoc(db, 'users', userId);
        const userDoc = await getDoc(userRef);
        
        if (userDoc.exists()) {
          const hasNeckLabels = userDoc.data().neckLabels === true;
          console.log(`User has neckLabels: ${hasNeckLabels}`);
          return hasNeckLabels;
        } else {
          console.log('User document does not exist');
          return false;
        }
      } catch (error) {
        console.error("Error fetching user document:", error);
        console.log(`Error details: ${error.message}`);
        return false;
      }
    };
  
    useEffect(() => {
      const checkUserNeckLabels = async () => {
        if (user && user.uid) {
          const hasNeckLabels = await checkNeckLabelsEnabled(user.uid);
          setNeckLabelsStatus(hasNeckLabels);
        }
      };
      
      checkUserNeckLabels();
    }, [user]);


  const neckLabelPrice = neckLabelsStatus ? 5 : 0;


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          const productsCollection = collection(db, 'users', user.uid, 'designs');
          const productsSnapshot = await getDocs(productsCollection);
          const productList = productsSnapshot.docs.map((firestoreDoc) => ({
            id: firestoreDoc.id,
            ...firestoreDoc.data(),
          }));
          setProducts(productList);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchProducts();
  }, []);
  
  // Calculate total price whenever selectedProducts changes
  useEffect(() => {
    const total = selectedProducts.reduce(
      (sum, product) => sum + (product.totalPrice+ neckLabelPrice) * product.quantity,
      0
    );
    setTotalPrice(total);
  }, [selectedProducts]);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  
  const handleAddProductClick = () => {
    setIsModalOpen(true);
  };
  
  const handleDeleteProduct = (productId) => {
    setSelectedProducts((prevProducts) => prevProducts.filter(product => product.id !== productId));
  };
  

  const getSKUForSize = (skus, size) => {
    if (!skus || !Array.isArray(skus)) return null;
    
    return skus.find((sku) => {
      const parts = sku.split('-');
      
      return (
        // Case 1: Size is second-to-last (with color variant)
        (parts.length >= 3 && parts[parts.length - 2] === size) ||
        // Case 2: Size is last (no color variant)
        (parts[parts.length - 1] === size)
      );
    });
  };
  
  // Helper function to check if a product (with its variant and size) already exists in the selected products
  const findExistingProduct = (products, newProduct) => {
    return products.find(
      (p) => 
        p.id === newProduct.id && 
        p.selectedSize === newProduct.selectedSize &&
        // Check if color variant matches (if exists)
        ((!p.variantData && !newProduct.variantData) || 
         (p.variantData && newProduct.variantData && 
          JSON.stringify(p.variantData) === JSON.stringify(newProduct.variantData)))
    );
  };
  


  const handleProductSelect = (product) => {
    // Determine which SKUs to use based on whether a color variant was selected
    const skusToUse = product.variantData ? product.variantData.SKUs : product.SKUs;
    
    // Get the SKU for the selected size
    const selectedSKU = getSKUForSize(skusToUse, product.selectedSize);
    
    if (!selectedSKU) {
      console.warn("No matching SKU found for size:", product.selectedSize);
      return;
    }
    
    setSelectedProducts((prevProducts) => {
      // Check if the exact same product (including variant and size) already exists
      const existingProduct = findExistingProduct(prevProducts, product);
      
      if (existingProduct) {
        // Increase quantity if the same product (with same variant and size) is selected again
        return prevProducts.map(p => 
          p === existingProduct 
            ? { ...p, quantity: p.quantity + 1 } 
            : p
        );
      } else {
        // Add new product with selected SKU
        return [
          ...prevProducts,
          { 
            ...product, 
            quantity: 1, 
            selectedSKU,
            // Ensure we keep the proper image structure
            images: product.variantData ? product.variantData.images : product.images,
          },
        ];
      }
    });
    
    setIsModalOpen(false);
  };
 

  const validateForm = () => {
    return Object.values(formData).every((value) => value.trim() !== "");
  };


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
            setUserId(user.uid); // Optionally set the email
        } else {
            toast.error('User not authenticated.');
        }
    });

    return () => unsubscribe();
}, []);

      useEffect(() => {
        const fetchWalletBalance = async () => {
            if (!userId) return;

            try {
                const walletRef = firestoreDoc(db, 'users', userId, 'wallet', 'walletDetails');
                const walletSnap = await getDoc(walletRef);
                if (walletSnap.exists()) {
                    const walletData = walletSnap.data();
                    setWalletBalance(walletData.balance);
                } else {
                    toast.error('Wallet not found. Please recharge.');
                }
            } catch (error) {
                console.error('Error fetching wallet balance:', error);
                toast.error('Error fetching wallet balance.');
            }
        };

        fetchWalletBalance();
    }, [userId]);



  const toWords = new ToWords({
          localeCode: "en-IN",
          converterOptions: {
            currency: true,
            ignoreDecimal: false,
            ignoreZeroCurrency: false,
            doNotAddOnly: false,
            currencyOptions: {
              name: "Rupee",
              plural: "Rupees",
              symbol: "₹",
              fractionalUnit: {
                name: "Paisa",
                plural: "Paise",
                symbol: "",
              },
            },
          },
        });


        const calculateShippingCharge = (order) => {
          // Assume userId is already available, for example, from auth.currentUser.uid
          const userId = auth.currentUser?.uid;  // Replace with actual userId if necessary
          
          let shippingCharge = 0;
          
          // If userId matches a specific user, apply custom shipping price
          if (userId === "hl6gcaUDIFXQkYUxppfAAHycLtO2") {
            // Custom shipping logic for this specific user
        
            const specialStates = [
              "North East", "J & K", "Ladakh", "Andaman & Nicobar", 
              "Himachal Pradesh", "Sikkim", "Lakshadweep",
              "Arunachal Pradesh", "Assam", "Manipur", "Meghalaya", 
              "Mizoram", "Nagaland", "Tripura"
            ];

            const billingState = order.state;
            const itemWeight = 0.25; // Base weight for calculating shipping cost
          
            // Calculate sub_total from selectedProducts
            const sub_total = selectedProducts.reduce((total, product) => {
              return total + product.sellingPrice * product.quantity;
            }, 0);
            
            // Check if the user is from one of the special states
            if (payment === "Prepaid") {
              if (billingState && specialStates.includes(billingState)) {
                shippingCharge = 85; // Apply special charge for prepaid if in special state
              } else {
                shippingCharge = 55; // Default prepaid charge
              }
            } else if (payment === "COD") {
              if (billingState && specialStates.includes(billingState)) {
                shippingCharge = 85; // Apply special charge for COD if in special state
              } else {
                shippingCharge = 65; // Default COD charge
              }
            }

            let totalWeight = 0;
            for (const product of selectedProducts) {
              if (product.quantity && typeof product.quantity === "number") {
                const productWeight = product.quantity * itemWeight;
                totalWeight += productWeight;
              }
            }
          
            const weightGroups = Math.ceil(totalWeight / 0.5); // Group by 0.5 kg
            shippingCharge *= weightGroups; // Multiply shipping by weight groups
          
            // Additional shipping charge logic for COD
            if (payment === "COD") {
              if (sub_total > 2000) {
                shippingCharge += sub_total * 0.025;
              } else {
                shippingCharge += 50; // Default additional charge for COD
              }
            }
        
            return shippingCharge; // Return custom shipping charge for the specific user
          }
        
          // Default logic for other users
          const specialStates = [
            "North East", "J & K", "Ladakh", "Andaman & Nicobar", 
            "Himachal Pradesh", "Sikkim", "Lakshadweep",
            "Arunachal Pradesh", "Assam", "Manipur", "Meghalaya", 
            "Mizoram", "Nagaland", "Tripura"
          ];
        
          const billingState = order.state;
          const itemWeight = 0.25; // Base weight for calculating shipping cost
        
          // Calculate sub_total from selectedProducts
          const sub_total = selectedProducts.reduce((total, product) => {
            return total + product.sellingPrice * product.quantity;
          }, 0);
        
          // Calculate shipping based on payment method and state
          if (payment === "Prepaid") {
            if (billingState && specialStates.includes(billingState)) {
              shippingCharge = 85; // Apply special charge for prepaid if in special state
            } else {
              shippingCharge = 65; // Default prepaid charge
            }
          } else if (payment === "COD") {
            if (billingState && specialStates.includes(billingState)) {
              shippingCharge = 85; // Apply special charge for COD if in special state
            } else {
              shippingCharge = 65; // Default COD charge
            }
          }
        
          // Calculate the total weight of products selected
          let totalWeight = 0;
          for (const product of selectedProducts) {
            if (product.quantity && typeof product.quantity === "number") {
              const productWeight = product.quantity * itemWeight;
              totalWeight += productWeight;
            }
          }
        
          const weightGroups = Math.ceil(totalWeight / 0.5); // Group by 0.5 kg
          shippingCharge *= weightGroups; // Multiply shipping by weight groups
        
          // Additional shipping charge logic for COD
          if (payment === "COD") {
            if (sub_total > 2000) {
              shippingCharge += sub_total * 0.025;
            } else {
              shippingCharge += 50; // Default additional charge for COD
            }
          }
        
          // Return the final calculated shipping charge
          return shippingCharge;
        };



    useEffect(() => {
        const orderDetails = {
          totalPrice,
          state: formData.state,
        };
        const calculatedShippingCharge = calculateShippingCharge(orderDetails);
        setShippingCharge(calculatedShippingCharge);
      }, [totalPrice, formData.state]); // Recalculate shipping charge



  const handleOrderSubmit = async (e) => {
    if (!validateForm()) {
      alert("Please fill in all required fields.");
      return;
    }

    // Fetch wallet details
    e.preventDefault();
    if (walletBalance < (totalPrice  + (totalPrice  * 0.05)) + calculateShippingCharge({state: formData.state}) + (calculateShippingCharge({state: formData.state}) * 0.18)) {
        toast.error('Insufficient balance. Please recharge your wallet.');
        return;
    }
    setIsModalOpen(true); // Show the confirmation modal

    // Check if the balance is sufficient
    if (walletBalance < (totalPrice  + (totalPrice * 0.05)) + calculateShippingCharge({state: formData.state}) + (calculateShippingCharge({state: formData.state}) * 0.18)) {
      toast.error('Insufficient balance. Recharge your wallet.', { onClose: () => setIsModalOpen(true) });
      return;
    }

    // Set balance after deduction and show confirmation modal
    setConfirmBalance(walletBalance - ((totalPrice  + (totalPrice * 0.05)) + calculateShippingCharge({state: formData.state}) + (calculateShippingCharge({state: formData.state}) * 0.18)));
    setShowConfirmModal(true);
  };

 

  const handleSizeChange = (e, index) => {
    const newSize = e.target.value;
    
    setSelectedProducts(prevProducts => {
      const updatedProducts = [...prevProducts];
      const product = updatedProducts[index];
      
      // Determine which SKUs array to use based on whether it's a variant
      const skusToUse = product.variantData ? product.variantData.SKUs : product.SKUs;
      
      // Find the SKU that matches the new size
      const newSKU = getSKUForSize(skusToUse, newSize);
      
      if (newSKU) {
        updatedProducts[index] = {
          ...product,
          selectedSize: newSize,
          selectedSKU: newSKU
        };
      } else {
        console.warn(`No SKU found for size ${newSize}`);
        // You might want to show an error message to the user here
      }
      
      return updatedProducts;
    });
  };

  function calculateVolumetricWeight(selectedProducts) {
    const baseDimensions = { L: 24, B: 19, H: 3 }; // Base dimensions for the first 2 items
    const stepIncrease = { L: 4, B: 4, H: 1 }; // Dimensions increase per additional 2 products
    
    const weightPerTShirt = 0.25; // Since 2 T-shirts make 1 slab of 0.5kg
    const weightPerBabyTee = 0.167; // Since 3 Baby Tees make 1 slab of 0.5kg
    
    let totalWeight = 0;
    let totalSlabs = 0;
    
    let maxLength = baseDimensions.L;
    let maxBreadth = baseDimensions.B;
    let maxHeight = baseDimensions.H;

    selectedProducts.forEach(product => {
        const quantity = product.quantity;
        const name = product.productName.toLowerCase();

        if (quantity && typeof quantity === "number" && quantity > 0) {
            let productWeight = 0;
            let slabs = 0;

            if (name.includes("t-shirt")) {
                productWeight = quantity * weightPerTShirt; // Calculate exact weight
                slabs = Math.ceil(quantity / 2); // Slabs are still based on grouping
            } else if (name.includes("baby tee")) {
                productWeight = quantity * weightPerBabyTee; // Calculate exact weight
                slabs = Math.ceil(quantity / 3);
            } else {
                slabs = Math.ceil(quantity / 2); // Default slab calculation for other products
                productWeight = slabs * 0.5; // Assuming default products follow the old slab rule
            }

            totalWeight += productWeight;
            totalSlabs = Math.max(totalSlabs, slabs); // Get max slabs for dimension calculation
        }
    });

    // Adjust dimensions based on the maximum slabs required
    maxLength = baseDimensions.L + (totalSlabs - 1) * stepIncrease.L;
    maxBreadth = baseDimensions.B + (totalSlabs - 1) * stepIncrease.B;
    maxHeight = baseDimensions.H + (totalSlabs - 1) * stepIncrease.H;

    return {
        length: maxLength,
        breadth: maxBreadth,
        height: maxHeight,
        weight: parseFloat(totalWeight.toFixed(3)), // Ensure the weight is rounded properly
    };
}

const handleConfirmOrder = async () => {

  if (isProcessing) {
    // If the order is already being processed, prevent further clicks
    return;
  }

  setIsProcessing(true); // Set to true when processing starts

  const unitee_order_id = `sample-${Date.now() % 1000000000}${Math.floor(Math.random() * 100)}`;

  const designSnapshot = await getDoc(firestoreDoc(db, "users", user.uid, "designs", design.id));
  let pickupLocation = "Printing Unit"; // Default location if no match
  let designData = null;
  
  if (designSnapshot.exists()) {
    designData = designSnapshot.data();

    // Ensure that printMethod exists in designData
    if (designData.printMethod) {
      if (designData.printMethod === "DTG Epson" || designData.printMethod === "DTF Epson") {
        pickupLocation = "Printing Unit 2";
      } else if (designData.printMethod === "DTG Brother") {
        pickupLocation = "Printing Unit";
      }
    }
  } else {
    console.warn(`No design found for SKU: ${design.id}`);
    return;
  }

  // Fetch brand information from Firestore
  const userRef = firestoreDoc(db, "users", user.uid);
  const userSnap = await getDoc(userRef);
  if (!userSnap.exists()) {
    console.error("Brand information not found.");
    return;
  }
  const userData = userSnap.data();

  let codCharges = 0;

  // Check if payment method is COD and fetch COD charges
  if (payment === "COD") {
      codCharges = userData.codCharges || 0;
  }
  
  const {length , breadth, height, weight} = calculateVolumetricWeight(selectedProducts)

  const subTotal = selectedProducts.reduce((total, product) => {
    return total + product.sellingPrice * product.quantity;
  }, 0) + codCharges;  // Add codCharges only if payment method is COD

  // Prepare order data with complete design data
  const orderData = {
    order_id: unitee_order_id,
    Storeorder_id: formData.ReferenceID,
    customer: {
      name: formData.name,
      email: formData.email,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      pinCode: formData.pincode,
      phone: formData.phone,
    },
    products: selectedProducts.map((product) => ({
      designName: product.designName,
      productName: product.productName,
      sellingPrice: product.sellingPrice * product.quantity,
      quantity: product.quantity,
      SKU: product.selectedSKU,
      selectedSize: product.selectedSize,
      designTotalPrice: product.totalPrice, // Base price from design
      neckLabelPrice: neckLabelPrice, // Additional cost for neck label
      itemTotalPrice: product.totalPrice + neckLabelPrice, // Combined total price
      // Add complete design data
      design: designData // This includes all design information
    })),
    sub_total: subTotal,
    totalPrice: (totalPrice + (totalPrice * 0.05)) + calculateShippingCharge({state: formData.state}) + (calculateShippingCharge({state: formData.state}) * 0.18),
    UniteeShipping: calculateShippingCharge({state: formData.state}) + (calculateShippingCharge({state: formData.state}) * 0.18),
    payment: payment,
    pickupLocation: pickupLocation, // Send the correct pickup location
    userId: user.uid,
    status: 'confirmed',
    length: length,
    breadth: breadth,
    height: height,
    weight: weight,
    isPaid: true,
    timestamp: Timestamp.now(),
  };

  // Create Sales Invoice only (Tax Invoice functionality removed)

// Create a function to generate abbreviation from brand name
function getAbbreviation(name) {
// Split the name into words
const words = name.split(' ');
// Take the first letter of each word and convert to uppercase
return words.map(word => word.charAt(0).toUpperCase()).join('');
}

// Get state abbreviation
function getStateAbbreviation(state) {
const stateAbbreviations = {
    'Andhra Pradesh': 'AP',
    'Arunachal Pradesh': 'AR',
    'Assam': 'AS',
    'Bihar': 'BR',
    'Chhattisgarh': 'CG',
    'Goa': 'GA',
    'Gujarat': 'GJ',
    'Haryana': 'HR',
    'Himachal Pradesh': 'HP',
    'Jharkhand': 'JH',
    'Karnataka': 'KA',
    'Kerala': 'KL',
    'Madhya Pradesh': 'MP',
    'Maharashtra': 'MH',
    'Manipur': 'MN',
    'Meghalaya': 'ML',
    'Mizoram': 'MZ',
    'Nagaland': 'NL',
    'Odisha': 'OD',
    'Punjab': 'PB',
    'Rajasthan': 'RJ',
    'Sikkim': 'SK',
    'Tamil Nadu': 'TN',
    'Telangana': 'TS',
    'Tripura': 'TR',
    'Uttar Pradesh': 'UP',
    'Uttarakhand': 'UK',
    'West Bengal': 'WB',
    'Andaman and Nicobar Islands': 'AN',
    'Chandigarh': 'CH',
    'Dadra and Nagar Haveli and Daman and Diu': 'DN',
    'Lakshadweep': 'LD',
    'Delhi': 'DL',
    'Puducherry': 'PY',
    'Jammu and Kashmir': 'JK',
    'Ladakh': 'LA'
    // Add more states as needed
};

return stateAbbreviations[state] || state.substring(0, 2).toUpperCase();
}

// Generate brand abbreviation
const brandAbbreviation = getAbbreviation(userData.brandName);
const stateAbbreviation = getStateAbbreviation(userData.state);
const financialYear = '25-26'; // You may want to calculate this dynamically

// Create the brand folder path
const brandFolderPath = `Sales_invoice/${brandAbbreviation}2026/`;
const salesInvoiceStorageRef = ref(Storage, brandFolderPath);

// Get the list of items (sales invoices) in this brand's folder
const salesListResult = await listAll(salesInvoiceStorageRef);
let nextSalesInvoiceNumber = 1;  // Default to 1 if no invoices exist

if (salesListResult.items.length > 0) {
// Extract the numeric part of each file name (e.g., 'MOS_MH_24-25_001.pdf')
const salesInvoiceNumbers = salesListResult.items
    .map(item => item.name.match(new RegExp(`${brandAbbreviation}_${stateAbbreviation}_${financialYear}_(\\d+)\\.pdf$`)))
    .filter(match => match)
    .map(match => parseInt(match[1], 10));

// Find the highest invoice number and increment it
if (salesInvoiceNumbers.length > 0) {
    nextSalesInvoiceNumber = Math.max(...salesInvoiceNumbers) + 1;
}
}

// Format the sales invoice number with the new pattern
const salesInvoiceNumber = `${brandAbbreviation}/${stateAbbreviation}/${financialYear}/${String(nextSalesInvoiceNumber).padStart(3, '0')}`;
const salesInvoiceFileName = `${brandAbbreviation}_${stateAbbreviation}_${financialYear}_${String(nextSalesInvoiceNumber).padStart(3, '0')}.pdf`;

const invoiceDate = new Date().toLocaleDateString('en-GB', {
  day: '2-digit',
  month: 'short',
  year: '2-digit',
});

// Create a new PDF for the sales invoice - use 112mm width for thermal printer
const salesDoc = new jsPDF({
orientation: 'portrait',
unit: 'mm',
format: [100, 150]  // 100mm thermal receipt width with variable height
});

// Set margins for thermal printer
const margin = 3; // 3mm margins
const width = 94; // 100mm - 2*3mm margins
const startX = margin;
const startY = margin;
let currentY = startY;
const lineHeight = 3.5; // line height for thermal receipt

// Header Section for Sales Invoice - centered
salesDoc.setFontSize(10);
salesDoc.setFont("Helvetica", "bold");
salesDoc.text('TAX Invoice', width/2 + startX, currentY += lineHeight, null, null, 'center');
currentY += lineHeight;

// Invoice Details - side by side due to wider format
salesDoc.setFontSize(7);
salesDoc.setFont("Helvetica", "normal");
salesDoc.text(`Date: ${invoiceDate}`, startX, currentY += lineHeight);
salesDoc.text(`Invoice #: ${salesInvoiceNumber}`, startX + width/2, currentY);
currentY += lineHeight/2;

// Add a divider line
salesDoc.line(startX, currentY, startX + width, currentY);
currentY += lineHeight/2;

// Bill From and Ship From side by side
const halfWidth = width / 2 - 2; // Leave a small gap between columns

function addWrappedText(doc, text, x, y, maxWidth, lineHeight) {
const words = text.split(' ');
let line = '';
let currentY = y;

for (let i = 0; i < words.length; i++) {
  const testLine = line + words[i] + ' ';
  const testWidth = doc.getStringUnitWidth(testLine) * doc.internal.getFontSize() / doc.internal.scaleFactor;
  
  if (testWidth > maxWidth && i > 0) {
    doc.text(line, x, currentY);
    line = words[i] + ' ';
    currentY += lineHeight;
  } else {
    line = testLine;
  }
}

if (line.trim() !== '') {
  doc.text(line.trim(), x, currentY);
}

return currentY;
}

// Bill From (Brand Info)
salesDoc.setFont("Helvetica", "bold");
salesDoc.text("Bill From:", startX, currentY += lineHeight);
salesDoc.setFont("Helvetica", "normal");
salesDoc.text(`${userData.brandName}`, startX, currentY += lineHeight);

const addressMaxWidth = halfWidth - 10;
currentY = addWrappedText(salesDoc, `${userData.address}`, startX, currentY += lineHeight, addressMaxWidth, lineHeight);

salesDoc.text(`${userData.state}, ${userData.pincode}`, startX, currentY += lineHeight);
salesDoc.text(`GST: ${userData.gstNumber}`, startX, currentY += lineHeight);

const billFromMaxY = currentY;

// Reset Y position for Ship From
const shipFromStartY = currentY - (lineHeight * 4);

// Ship From
salesDoc.setFont("Helvetica", "bold");
salesDoc.text("Ship From:", startX + halfWidth + 5, shipFromStartY);
salesDoc.setFont("Helvetica", "normal");
salesDoc.text("Jalandhar", startX + halfWidth + 5, shipFromStartY + lineHeight);
salesDoc.text("Punjab", startX + halfWidth + 5, shipFromStartY + lineHeight * 2);
salesDoc.text("144004", startX + halfWidth + 5, shipFromStartY + lineHeight * 3);

// Add a divider line
currentY += lineHeight/2;
salesDoc.line(startX, currentY, startX + width, currentY);
currentY += lineHeight/2;

const billToShipToStartY = currentY;

// Bill To section
salesDoc.setFont("Helvetica", "bold");
salesDoc.text("Bill To:", startX, billToShipToStartY + lineHeight);
salesDoc.setFont("Helvetica", "normal");
salesDoc.text(`${formData.name}`, startX, billToShipToStartY + lineHeight * 2);

let billToY = billToShipToStartY + lineHeight * 3;
billToY = addWrappedText(salesDoc, `${formData.address}`, startX, billToY, addressMaxWidth, lineHeight);
billToY = addWrappedText(salesDoc, `${formData.city}, ${formData.state}`, startX, billToY += lineHeight, addressMaxWidth, lineHeight);
salesDoc.text(`${formData.pincode}`, startX, billToY += lineHeight);

// Ship To section - starts at the same Y level as Bill To
salesDoc.setFont("Helvetica", "bold");
salesDoc.text("Ship To:", startX + halfWidth + 5, billToShipToStartY + lineHeight);
salesDoc.setFont("Helvetica", "normal");
salesDoc.text(`${formData.name}`, startX + halfWidth + 5, billToShipToStartY + lineHeight * 2);

let shipToY = billToShipToStartY + lineHeight * 3;
shipToY = addWrappedText(salesDoc, `${formData.address}`, startX + halfWidth + 5, shipToY, addressMaxWidth, lineHeight);
shipToY = addWrappedText(salesDoc, `${formData.city}, ${formData.state}`, startX + halfWidth + 5, shipToY += lineHeight, addressMaxWidth, lineHeight);
salesDoc.text(`${formData.pincode}`, startX + halfWidth + 5, shipToY += lineHeight);

// Find the maximum Y position between the two sections
currentY = Math.max(billToY, shipToY) + lineHeight;

// Add a divider line
currentY += lineHeight/2;
salesDoc.line(startX, currentY, startX + width, currentY);
currentY += lineHeight/2;

// Items header
salesDoc.setFont("Helvetica", "bold");
salesDoc.text("ITEMS", startX, currentY += lineHeight);
currentY += lineHeight/2;

// Add a divider line
salesDoc.line(startX, currentY, startX + width, currentY);
currentY += lineHeight;

// Column headers for items - more columns possible with 100mm width
salesDoc.setFontSize(6);
salesDoc.text("Item", startX, currentY += lineHeight);
salesDoc.text("HSN", startX + 35, currentY, null, null, 'center');
salesDoc.text("Qty", startX + 50, currentY, null, null, 'center');
salesDoc.text("Price", startX + 65, currentY, null, null, 'center');
salesDoc.text("Tax", startX + 80, currentY, null, null, 'center');
salesDoc.text("Amount", startX + width, currentY, null, null, 'right');
currentY += lineHeight/2;

// Add a divider line
salesDoc.line(startX, currentY, startX + width, currentY);
currentY += lineHeight/2;

let totalSubtotal = 0;
let totalTaxableValue2 = 0;
let totalCGST2 = 0;
let totalSGST2 = 0;
let totalIGST2 = 0;
let totalTaxAmount = 0;

// Use product data directly
salesDoc.setFont("Helvetica", "normal");

selectedProducts.forEach(product => {
// Calculate the individual item price (total including tax)
const itemPrice = (parseFloat(product.sellingPrice) || 0) * product.quantity;
totalSubtotal += itemPrice;

// Determine tax rate based on item's price
const taxRate = ((parseFloat(product.sellingPrice) || 0) >= 1000) ? 0.12 : 0.05; // 12% if price >= 1000, 5% otherwise

// Calculate taxable value (price excluding tax)
const taxMultiplier = 1 + taxRate;
const taxableValue = itemPrice / taxMultiplier;
totalTaxableValue2 += taxableValue;

let cgstAmt = 0;
let sgstAmt = 0;
let igstAmt = 0;
let taxAmount = 0;
let taxDisplay = "";

// Apply tax based on the rule
if (userData.state === "Maharashtra") {
cgstAmt = taxableValue * (taxRate/2);
sgstAmt = taxableValue * (taxRate/2);
taxAmount = cgstAmt + sgstAmt;
totalCGST2 += cgstAmt;
totalSGST2 += sgstAmt;
taxDisplay = `${(taxRate*100).toFixed(0)}% (C+S)`;
} else {
igstAmt = taxableValue * taxRate;
taxAmount = igstAmt;
totalIGST2 += igstAmt;
taxDisplay = `${(taxRate*100).toFixed(0)}% (IGST)`;
}
totalTaxAmount += taxAmount;

// Truncate product name if too long
const productName = (product.productName || 'Unknown').substring(0, 18);

// Print item details
salesDoc.text(productName, startX, currentY += lineHeight);
salesDoc.text('610910', startX + 35, currentY, null, null, 'center');
salesDoc.text(product.quantity.toString(), startX + 50, currentY, null, null, 'center');
salesDoc.text((parseFloat(product.sellingPrice) || 0).toFixed(2), startX + 65, currentY, null, null, 'center');
salesDoc.text(taxDisplay, startX + 80, currentY, null, null, 'center');
salesDoc.text(itemPrice.toFixed(2), startX + width, currentY, null, null, 'right');
currentY += lineHeight;
});

// Add a divider line
currentY += lineHeight/2;
salesDoc.line(startX, currentY, startX + width, currentY);
currentY += lineHeight/2;

// Summary section - more detailed for 100mm receipt
salesDoc.setFont("Helvetica", "bold");
salesDoc.text("SUMMARY", startX, currentY += lineHeight);
currentY += lineHeight/2;

// Add a divider line
salesDoc.line(startX, currentY, startX + width, currentY);
currentY += lineHeight;

salesDoc.setFontSize(7); 
// Display subtotal and tax details in a more structured format
salesDoc.setFont("Helvetica", "normal");
salesDoc.text("Subtotal (Excl. Tax):", startX, currentY += lineHeight);
salesDoc.text(totalTaxableValue2.toFixed(2), startX + width, currentY, null, null, 'right');

// Display appropriate tax summary based on state
if (userData.state === "Maharashtra") {
// Just display CGST and SGST without percentage
salesDoc.text("CGST:", startX, currentY += lineHeight);
salesDoc.text(totalCGST2.toFixed(2), startX + width, currentY, null, null, 'right');

salesDoc.text("SGST:", startX, currentY += lineHeight);
salesDoc.text(totalSGST2.toFixed(2), startX + width, currentY, null, null, 'right');
} else {
// Just display IGST without percentage
salesDoc.text("IGST:", startX, currentY += lineHeight);
salesDoc.text(totalIGST2.toFixed(2), startX + width, currentY, null, null, 'right');
}

// Total tax amount
salesDoc.text("Total Tax:", startX, currentY += lineHeight);
salesDoc.text(totalTaxAmount.toFixed(2), startX + width, currentY, null, null, 'right');

// Add a divider line
currentY += lineHeight/2;
salesDoc.line(startX, currentY, startX + width, currentY);
currentY += lineHeight/2;

// Total amount - make it stand out
salesDoc.setFontSize(9);
salesDoc.setFont("Helvetica", "bold");
salesDoc.text("TOTAL:", startX, currentY += lineHeight);
salesDoc.text(totalSubtotal.toFixed(2), startX + width, currentY, null, null, 'right');

// Amount in words
currentY += lineHeight;
salesDoc.setFontSize(6);
salesDoc.setFont("Helvetica", "normal");
const amountInWords = toWords.convert(totalSubtotal);
// Split amount in words into multiple lines if needed
const wordsArray = salesDoc.splitTextToSize(`Amount in words: ${amountInWords}`, width);
wordsArray.forEach(line => {
salesDoc.text(line, startX, currentY += lineHeight - 1);
});

// Add a divider line
currentY += lineHeight/2;
salesDoc.line(startX, currentY, startX + width, currentY);
currentY += lineHeight/2;

// Footer notes
salesDoc.setFontSize(6);
salesDoc.text("Note: All prices include applicable taxes.", startX, currentY += lineHeight);
salesDoc.text("Thanks for your business.", startX, currentY += lineHeight);

// Signature line
currentY += lineHeight;
salesDoc.line(startX + width/4, currentY, startX + width*3/4, currentY);
currentY += lineHeight;
salesDoc.text("Authorized Signature", startX + width/2, currentY, null, null, 'center');

// Generate the sales invoice PDF file
const salesPdfBlob = salesDoc.output('blob');

// Upload only the sales invoice
const salesInvoiceUploadPromise = new Promise((resolve, reject) => {
const salesInvoiceRef = ref(Storage, `${brandFolderPath}${salesInvoiceFileName}`);
const salesUploadTask = uploadBytesResumable(salesInvoiceRef, salesPdfBlob);

salesUploadTask.on(
  'state_changed',
  snapshot => {
    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    console.log(`Sales Invoice Upload is ${progress}% done`);
  },
  error => {
    console.error('Error uploading sales invoice:', error);
    toast.error('Error uploading sales invoice');
    reject(error);
  },
  async () => {
    try {
      const salesDownloadURL = await getDownloadURL(salesUploadTask.snapshot.ref);
      console.log('Sales Invoice uploaded, download URL:', salesDownloadURL);
      resolve(salesDownloadURL);
    } catch (err) {
      reject(err);
    }
  }
);
});

try {
const salesInvoiceUrl = await salesInvoiceUploadPromise;

// Update orderData with sales invoice URL
orderData.salesInvoiceUrl = salesInvoiceUrl;

// Make the API call with sales invoice URL included
const response = await axios.post('https://ufb-1.onrender.com/create-sample-order', orderData, {
  headers: { 'Content-Type': 'application/json' },
});
console.log('Order created on Shiprocket successfully:', response.data);

// Update wallet balance
const walletRef = firestoreDoc(db, 'users', user.uid, 'wallet', 'walletDetails');
await updateDoc(walletRef, { balance: confirmBalance });

// Record transaction
const transactionsRef = collection(walletRef, 'transactions');
const transactionData = {
  type: unitee_order_id,
  amount: (totalPrice + (totalPrice * 0.05)) + calculateShippingCharge({state: formData.state}) + (calculateShippingCharge({state: formData.state}) * 0.18),
  balanceBefore: walletBalance,
  balanceAfter: confirmBalance,
  timestamp: Timestamp.now(),
};
await addDoc(transactionsRef, transactionData);

toast.success("Order submitted successfully!");
setShowConfirmModal(false);

} catch (error) {
console.error('Error handling completed upload:', error);
toast.error("Error completing the order.");
} finally {
setIsProcessing(false); // Reset the flag when the process is complete
}
}

  const handleQuantityChange = (e, index) => {
    const updatedProducts = [...selectedProducts];
    const product = updatedProducts[index];
    const newQuantity = e.target.value;
  
    // Handle input where quantity is empty (let it be empty until the user types a valid value)
    if (newQuantity === "") {
      product.quantity = "";  // Temporarily empty until user enters something valid
    } else {
      const parsedQuantity = parseInt(newQuantity, 10);
  
      // Only update if parsedQuantity is a valid number and greater than or equal to 1
      if (!isNaN(parsedQuantity) && parsedQuantity >= 1) {
        product.quantity = parsedQuantity;
      } else {
        return; // Do not update if the parsed value is not valid
      }
    }
  
    setSelectedProducts(updatedProducts);
  };
  

  if (loading) {
    return <div>Loading products...</div>;
  }

  return (

<div className="placeorder-page">
  <Header />
  <div className="products-container">
    <Sidebar />
    <div className="main-content">
      {step === "product" && (
        <div className="product-selection">
          <h1>Place Order</h1>
          <button className="add-order-button" onClick={handleAddProductClick}>
            Add Product to Order
          </button>
          
          {/* Modal for product selection */}
          <ProductSelectionPopup
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            products={products}
            onSelectProduct={handleProductSelect}
          />
          
          {/* Display selected products */}
         {/* Display selected products */}
{selectedProducts.map((product, index) => (
  <div key={index} className="product-details">
    <h2>{product.productName}</h2>
    <p>{product.description}</p>
    
    {/* Use the proper images based on whether it's a variant or not */}
 
     
        <img 
          src={product.variantData ? product.variantData.images.front : product.images.front} 
          alt="Front Mockup" 
          width="150" 
        />
      
        <img 
          src={product.variantData ? product.variantData.images.back : product.images.back} 
          alt="Back Mockup" 
          width="150" 
        />

    {/* Display variant info if applicable */}
    {product.variantData && product.variantData.color && (
      <div className="variant-info">
        <p>Color: {product.variantData.color}</p>
      </div>
    )}
    <p>Total Price: Rs. {(product.totalPrice) * product.quantity}</p>
    <p>Neck Label Price: Rs. {(neckLabelPrice) * product.quantity}</p>
    {/* Size input */}
    <div className="size-section">
      <label>Size:</label>
      <select
        value={product.selectedSize}
        onChange={(e) => handleSizeChange(e, index)}
      >
        <option value="">Select Size</option>
        <option value="S">S</option>
        <option value="M">M</option>
        <option value="L">L</option>
        <option value="XL">XL</option>
      </select>
    </div>
    
    {/* Editable Quantity */}
    <div className="quantity-section">
      <label>Quantity:</label>
      <input
        type="number"
        min="1"
        value={product.quantity}
        onChange={(e) => handleQuantityChange(e, index)}
      />
    </div>
    
    <button
      className="delete-product-button"
      onClick={() => handleDeleteProduct(product.id)}
    >
      Delete
    </button>
  </div>
))}
          <p className="total-price">Total Price: Rs. {totalPrice}</p>
          
          <button 
            className="submit-order-button" 
            onClick={() => setStep("shipping")}
            disabled={selectedProducts.length === 0}
          >
            Proceed to Shipping
          </button>
        </div>
      )}

      {step === "shipping" && (
        <div className="shipping-form">
          <h1>Shipping Details</h1>
          {Object.keys(formData).map((field) => (
            <div key={field}>
              <label htmlFor={field}>{field.charAt(0).toUpperCase() + field.slice(1)}:</label>
              <input
                type="text"
                id={field}
                name={field}
                value={formData[field]}
                onChange={handleInputChange}
                required
              />
            </div>
          ))}
          <button className="submit-order-button" onClick={() => setStep("review")}>
            Review Order
          </button>
        </div>
      )}

{step === "review" && (
  <div className="review-order">
    <h1>Review Order</h1>
    <h2>Customer Details</h2>
    {Object.entries(formData).map(([key, value]) => (
      <p key={key}>
        {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
      </p>
    ))}

    <h2>Products</h2>
    {selectedProducts.map((product, index) => (
      <div key={index} className="product-details">
        <h3>{product.productName}</h3>
        <p>Size: {product.selectedSize}</p>
        <p>Quantity: {product.quantity}</p> {/* Display quantity */}
        <p>Selling Price: Rs. {product.sellingPrice * product.quantity}</p>
        <p>Price: Rs. {(product.totalPrice + neckLabelPrice) * product.quantity}</p>
         {/* Display price based on quantity */}
        
      </div>
    ))}

<h3>Shipping Charge(tax inclusive): ₹{(calculateShippingCharge({state: formData.state}) + (calculateShippingCharge({state: formData.state}) * 0.18)).toFixed(2)}</h3>
{/* <h3>Total Price (inclusive of 5% tax): Rs. {totalPrice + calculateShippingCharge({state: formData.state}) + (totalPrice + calculateShippingCharge({state: formData.state})) * 0.05}</h3> */}

<h3>Total Price (inclusive of 5% tax): Rs. {((totalPrice + ((totalPrice) * 0.05)) + calculateShippingCharge({state: formData.state}) + (calculateShippingCharge({state: formData.state}) * 0.18)).toFixed(2)}</h3>


    <h2>Select Payment Method</h2>
    <div className="payment-method-options">
      <label>
        <input 
          type="radio" 
          name="payment" 
          value="COD" 
          checked={payment === 'COD'}
          onChange={(e) => setPayment(e.target.value)}
        />
        COD
      </label>
      <label>
        <input 
          type="radio" 
          name="payment" 
          value="Prepaid" 
          checked={payment === 'Prepaid'}
          onChange={(e) => setPayment(e.target.value)}
        />
        Prepaid
      </label>
    </div>
    
    <button className="submit-order-button" onClick={handleOrderSubmit}>
      Submit Order
    </button>
  </div>
)}

      {/* Confirmation Modal */}
      <Modal
        isOpen={showConfirmModal}
        onRequestClose={() => setShowConfirmModal(false)}
        className="confirmation-modal"
      >
        <h2>Confirm Your Order</h2>
        <p>{((totalPrice + ((totalPrice) * 0.05)) + calculateShippingCharge({state: formData.state}) + (calculateShippingCharge({state: formData.state}) * 0.18)).toFixed(2)}</p>
        <button className="confirm-button" onClick={handleConfirmOrder} disabled={isProcessing}>
        {isProcessing ? "Processing..." : "Confirm Order"}
        </button>
        <button className="cancel-button" onClick={() => setShowConfirmModal(false)}>
          Cancel
        </button>
      </Modal>
         </div>
      </div>
      <ToastContainer />
    </div>
  );
};
export default PlaceOrder;